"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GET_PRODUCTS = void 0;
/**
 * @warning If the structure of this query changes, remember to update useOptimisticUpdateAttributes hook
 */
const gql_1 = require("../../../../__generated__/gql");
exports.GET_PRODUCTS = (0, gql_1.gql)(`
  query Products(
    $catalogId: ID!,
    $productTreeNodeId: ID!,
    $productTreeId: ID!,
    $filter: ProductPresentationFilter,
    $labelFilter: [ProductLabelFilter!],
    $measureFilter: ProductMeasureFilter,
    $sort: ProductPresentationOrderByNew,
    $skipMeasures: Boolean!,
    $first: Int,
    $after: ID,
    $last: Int,
    $before: ID,
    $shouldFetchReviewStatus: Boolean!,
    $reviewStatusAttribute: String! = "",
    $reviewStatusAttributeType: ProductAttributeType! = LABEL,
    $shouldFetchLockedCount: Boolean! = false,
    $lockedProductsFilter: ProductPresentationFilter,
    $labelValidationFilter: ProductTreeNodeUniqueLabelListFilter,
    $skipLabelValidation: Boolean! = true,
    $includeLabelExplanation: Boolean! = true,
  ) {
  productTreeNode(id: $productTreeNodeId) {
    id
    title
    productPresentationsNew(
      catalog: $catalogId,
      first: $first,
      after: $after,
      last: $last,
      before: $before,
      filter: $filter,
      orderBy: $sort,
    ) {
      edges {
        node {
          product {
            ...ProductFragment
            labels(filters: $labelFilter) {
              edges {
                node {
                  status
                  label
                  value
                  origin
                  explanation @include(if: $includeLabelExplanation)
                }
              }
            }
            measures (filter: $measureFilter, first: 2000) @skip (if: $skipMeasures) {
              edges {
                node {
                  unit
                  value
                  origin
                  dimension
                }
              }
            }
            reviewedStatus (attribute: $reviewStatusAttribute, attributeType: $reviewStatusAttributeType) @include(if: $shouldFetchReviewStatus)
            lastReviewedBy (attribute: $reviewStatusAttribute, attributeType: $reviewStatusAttributeType) @include(if: $shouldFetchReviewStatus) {
              id
              name
            }
            presentations(catalog: $catalogId, productTrees: [$productTreeId], first: 1) {
              edges {
                node {
                  productTreeNodeId
                  productTreeNode @skip (if: $skipLabelValidation) {
                    labelValidation(filter: $labelValidationFilter) {
                      edges {
                        node {
                          label
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
      pageInfo {
        startCursor
        endCursor
      }
      totalCount
    }
    lockedProductPresentations: productPresentationsNew(
      catalog: $catalogId,
      first: 0,
      filter: $lockedProductsFilter
    ) @include(if: $shouldFetchLockedCount) {
      totalCount
    }
  }
}`);
